var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBottomNavMarketplaceIconMobDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.513 4.298l-.744-3.096A1.392 1.392 0 0012.416.125H2.574c-.638 0-1.197.446-1.346 1.077L.484 4.298c-.17.723-.014 1.46.44 2.041.056.078.134.135.197.206v4.917c0 .78.638 1.417 1.418 1.417h9.92c.779 0 1.417-.638 1.417-1.417V6.545c.063-.064.141-.128.198-.199a2.384 2.384 0 00.44-2.048zm-2.118-2.763l.744 3.096a.96.96 0 01-.178.83.831.831 0 01-.665.332c-.433 0-.808-.347-.858-.807l-.41-3.444 1.367-.007zm-4.188.007h1.389l.382 3.203a.952.952 0 01-.233.758c-.156.184-.383.29-.673.29-.475 0-.865-.418-.865-.928V1.542zM5.011 4.745l.39-3.203H6.79v3.323a.91.91 0 01-.914.928.853.853 0 01-.63-.29 1.007 1.007 0 01-.235-.758zM1.858 4.63l.716-3.089H3.97l-.411 3.444c-.057.46-.425.807-.857.807a.816.816 0 01-.66-.333.937.937 0 01-.184-.829z",
    fill: "#999"
  })));
}

export default SvgBottomNavMarketplaceIconMobDisabled;